import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { IConfiguration } from './types';

const path = '/configuration-service/configurations';

export const requestUpdateConfiguration = (configurationData: IConfiguration) => {
  return mutate(path, async() => {
    try {
      await axios.patch(`${path}/${configurationData.id}`, configurationData);
      Notistack.successMessage('Configuration - Updated Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

export const requestCreateConfiguration = (ruleData: IConfiguration) => {
  return mutate(path, async() => {
    try {
      await axios.post(path, ruleData);
      Notistack.successMessage('Configuration - Created Successfully');
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
    }
  });
};

